import { Heading, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

type PatientHeadingProps = {
   readonly firstName: string | null;
   readonly lastName: string | null;
};

export const PatientHeading = (props: PatientHeadingProps): JSX.Element | null => {
   return (
      <Heading
         type={'h2'}
         bold
         testId={'patientName'}
         content={
            <TextSeparator separator={TextSeparatorType.SPACE}>
               {props.firstName ? <Text testId={'firstName'}>{props.firstName}</Text> : null}
               {props.lastName ? <Text testId={'lastName'}>{props.lastName}</Text> : null}
            </TextSeparator>
         }
         margin={'0px'}
      />
   );
};
